import injectSheet from 'core/style/injectSheet';
import { WithStyles } from 'core/style/interfaces';
import React from 'react';
import { ExpandCards, IExpandCardsProps, styles } from './ExpandCards';

type IExpandCardsWithFetchProps = {
    isFetching: boolean;
    count: number;
    fetchOnOpen: () => void;
} & Omit<IExpandCardsProps, 'expand' | 'collapse' | 'isOpen'> &
    WithStyles<typeof styles>;

type IExpandCardsWithFetchState = {
    isOpen: boolean;
    isOpened: boolean;
};

class ExpandCardsWithFetch extends React.Component<IExpandCardsWithFetchProps, IExpandCardsWithFetchState> {
    state: IExpandCardsWithFetchState = {
        isOpen: false,
        isOpened: false,
    };

    handleClose = () => this.setState({ isOpen: false });

    handleOpen = () => {
        !this.state.isOpened && this.props.fetchOnOpen();
        this.setState({ isOpen: true, isOpened: true });
    };

    render() {
        const { isFetching, count } = this.props;

        return (
            <ExpandCards
                {...this.props}
                totalItemsCount={count}
                isFetching={isFetching}
                isOpen={this.state.isOpen}
                collapse={this.handleClose}
                expand={this.handleOpen}
            />
        );
    }
}

export default injectSheet(styles, 'ExpandCards')(ExpandCardsWithFetch);
